namespace AgerLMS.LMS {
    export interface DeleteUserVideoFileRequest extends Serenity.ServiceRequest {
        EntityId?: number;
        DeleteOnlyFile?: boolean;
        DeleteEntity?: boolean;
        UpdateToQueue?: boolean;
    }
}
